export default __webpack_public_path__ + "static/media/arrow.a2fdcf1b.svg";